import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss'],
})
export class HelpModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: UserApiService,
    private apiMarket: MarketingApiService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getArticles(this.data.problemInfo.help_articles);
  }

  openAiCustomerService() {
    this.getDingdingData();
  }

  async getDingdingData() {
    try {
      const r = await this.api.getDingdingData();
      const dingding_url = r.data.access_url;
      window.open(dingding_url);
    } catch (error) {}
  }

  loading = false;
  articleList: any;
  async getArticles(ids: number[]) {
    try {
      this.loading = true;
      const requests = ids.map((id) =>
        this.apiMarket.findArticles('', id, 1, 10),
      );
      const results = await Promise.all(requests);
      this.articleList = results.map((r) => r.data);
      console.log(this.articleList);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  gotoArticle(item: any) {
    this.router.navigate([
      `/helping/detail/${item.tag_id}/p/${1}/article/${item.id}`,
    ]);
  }
}
